import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingController, NavController } from '@ionic/angular';
import { Mirador } from 'src/app/models/mirador';
import { MiradoresService } from 'src/app/services/miradores.service';
import { AuthService } from 'src/app/services/auth.service';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { ToastController } from '@ionic/angular';
import { HomeService } from 'src/app/services/home.service';
import { MedalsService } from 'src/app/services/medals.service';
import { take } from 'rxjs';
import { Experience } from 'src/app/models/ToursModels';
import { ExperienceService } from 'src/app/services/experience.service';
import { VisitsExperiencesService } from 'src/app/services/visits-experiences.service';

@Component({
  selector: 'app-experience-record-visit',
  templateUrl: './experience-record-visit.page.html',
  styleUrls: ['./experience-record-visit.page.scss'],
})
export class ExperienceRecordVisitPage implements OnInit {
  experienceDisplayed: Experience;
  experienceLink = '';
  loading;

  public miradorDisplayed: Mirador = null;
  public buffer = 0.06;
  public progress = 0;

  images = [
    '/assets/sample-images/record-visit/1.webp',
    '/assets/sample-images/record-visit/2.webp',
    '/assets/sample-images/record-visit/3.webp',
    '/assets/sample-images/record-visit/4.webp',
    '/assets/sample-images/record-visit/5.webp',
    '/assets/sample-images/record-visit/6.webp',
  ];

  currentSesion: any;
  currentUploadedImageURL: string;
  step: number;
  getStep1Iamg;
  getStep2Iamg;

  imageChangedEvent: any = '';
  croppedImage: any = '';
  isCutting: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private MIService: MiradoresService,
    private navCtrl: NavController,
    private visitService: VisitsExperiencesService,
    public auth: AuthService,
    private toastController: ToastController,
    private homeService: HomeService,
    private medalsService: MedalsService,
    private experienceService: ExperienceService,
    private router: Router,
    private loadingController: LoadingController,
  ) {
    this.getExperience();
  }

  ngOnInit() {
    this.step = 1;

    setInterval(() => {
      this.buffer += 0.06;
      this.progress += 0.06;

      // Reset the progress bar when it reaches 100%
      // to continuously show the demo
      if (this.progress > 1) {
        setTimeout(() => {
          this.buffer = 0.06;
          this.progress = 0;
        }, 1000);
      }
    }, 1000);
    this.getStep1Iamg = this.getImageRandom();
    this.getStep2Iamg = this.getImageRandom();
  }

  async getExperience() {
    const navigation = this.router.getCurrentNavigation();
    if (navigation && navigation.extras?.state) {
      this.experienceDisplayed = navigation.extras.state.experience;
      this.experienceLink = `https://med.miradores.co/experience/${this.experienceDisplayed._id}`;

    } else {
      this.presentLoading();
      this.experienceService.getExperiences();
      this.experienceService.$experiencesLoaded.subscribe((loaded) => {
        if (loaded) {
          this.route.paramMap.subscribe((params) => {
            this.experienceDisplayed = this.experienceService.getExperienceByID(
              params.get('experience')
            );
            this.experienceLink = `https://med.miradores.co/experience/${this.experienceDisplayed._id}`;
          });
        }
      });
    }
    this.getSession();
  }

  async presentLoading() {
    this.loading = await this.loadingController.create({
      duration: 3200,
      translucent: true,
      backdropDismiss: false,
    });
    await this.loading.present();
  }

  getImageRandom() {
    return this.images[Math.floor(Math.random() * this.images.length)];
  }


  goBack() {
    this.navCtrl.back();
  }

  getSession() {
    this.auth.$establishedSession.subscribe((user) => {
      this.currentSesion = user;
    });
  }

  goStep(step) {
    this.step = step;
  }

  fileChangeEvent(event) {
    this.imageChangedEvent = event;
    const file = event.target.files[0];
    const img = new Image();

    img.onload = async () => {
      if (img.width < 480) {
        const toast = await this.toastController.create({
          message: 'Selecciona una imagen de minimo 1080px de ancho',
          position: 'top',
          color: 'tertiary',
          buttons: [
            {
              icon: 'close-circle-outline',
              role: 'cancel',
            },
          ],
        });
        await toast.present();
      } else {
        this.isCutting = true;
      }
    };

    img.src = URL.createObjectURL(file);
  }

  cancelCut() {
    this.isCutting = false;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  cutAndUpload() {
    const photoName = this.experienceDisplayed.title + Date.now() + '.png';
    this.isCutting = false;
    this.step = 3;

    const userId = this.currentSesion?.uid || 'FW33GcNgH8eYFgOqFQQvvepWu9W2';
    this.visitService
      .uploadImageFromVisit(this.croppedImage, userId, photoName)
      .then(
        (urlImage) => {
          this.visitService
            .SetVisitData(this.currentSesion, this.experienceDisplayed, urlImage)
            .then(() => {
              this.currentUploadedImageURL = this.croppedImage;
              this.step = 4;
              this.auth.SyncMyVisitsExperiences();
              this.assignMedalTraveler();
              // this.manageGrowthNotificationsViaWhatsApp();
              let createPostSuscription = this.auth.$myLastVisitExperience.subscribe(
                (lastVisitExperience) => {
                  console.log(`lastVisitExperience clg ${lastVisitExperience}`);
                  this.homeService.createVisitExperiencePosts([lastVisitExperience]);
                  createPostSuscription.unsubscribe();
                }
              );
            });
        },
        (error) => {
          console.error(error);
        }
      );
  }

  assignMedalTraveler() {
    this.auth.$myExperiencesVisited.pipe(
      take(2)
    ).subscribe((visitsUser) => {

      if (visitsUser.length <= 1 && visitsUser.length > 0) {

        let hasMedalExplorer = false;
        this.auth.$establishedSession.pipe(
          take(1)
        ).subscribe((user) => {
          if (user.medalsObtained) {
            hasMedalExplorer = user.medalsObtained.some(
              (medal) => medal.medalId === 'AG5zus0xt0fcLYi9Gg7C'
            );
          }

          if (!hasMedalExplorer) {
            if (!user.medalsObtained) {
              user.medalsObtained = [];
            }
            user.medalsObtained.push({
              medalId: 'AG5zus0xt0fcLYi9Gg7C',
              dateEarned: new Date(),
            });
            this.medalsService.SetDataUserMedal(user).then(() => {
              this.auth.updateCurrentSession(user);
              this.medalsService.showAlertMedal('Viajero');
            });

          }
        });

      }
    });
  }



  manageGrowthNotificationsViaWhatsApp() {
    this.auth.$myMiradoresVisited.pipe(
      take(1)
    ).subscribe((visitsUser) => {
      const numberOfVisits = visitsUser.length;

      if (numberOfVisits > 0) {
        const user = this.currentSesion;

        if (numberOfVisits === 1) {
          this.medalsService.inviteFriendsToDownloadApp(user, visitsUser[0]);
        } else if (numberOfVisits === 5) {
          this.medalsService.inviteFriendsAfter5Visits(user, visitsUser);
        } else if (numberOfVisits === 8) {
          this.medalsService.requestAppRatingAfter8Visits(user, visitsUser);
        }
      }
    });
  }

}
